const pattern = /^sse-(.+?)-(control|variant\d+)$/;

/**
 * Returns the name of the server-side experiment from the document's class list.
 * The expected format is `sse-{experimentName}-{control|variantX}`.
 *
 * @returns {string | undefined} The experiment name and variant, or undefined if not found.
 */
export function getServerSideExperimentName(): string | undefined {
  const classList = document.documentElement.classList;

  for (const className of classList) {
    const match = className.match(pattern);

    if (match) {
      const [, experimentName, experimentVariant] = match;

      return `${experimentName}-${experimentVariant}`;
    }
  }

  return;
}
